import React from 'react'
import Form from '../Components/Form'

const Contact = () => {
  return (
    <div style={{ width: '100%', flex: 1, display: 'flex', justifyContent: 'center' }}>
      <Form />
    </div>
  )
}

export default Contact